















































import { Vue, Component, Prop } from "vue-property-decorator";
import { Company } from "../../models";

export class InfoEntry {
  label: string;
  value: string | number;
}

@Component({})
export default class Info extends Vue {
  @Prop()
  company: Company;

  get additionalData() {
    if (!this.company) {
      return undefined;
    }
    return [
      {
        label: "Countries",
        value: this.company.countries?.map((o) => o.fullName).join(", "),
      },
      {
        label: "Currency",
        value: this.company.currency.fullName,
      },
      {
        label: "Language",
        value: this.company.language.fullName,
      },
      {
        label: "Notes",
        value: this.company.notes || "-",
      },
    ];
  }

  get taxData() {
    if (!this.company) {
      return undefined;
    }
    return [
      { label: "Name", value: this.company.name },
      {
        label: "Business name",
        value: this.company.businessName,
      },
      {
        label: "Address",
        value: this.company.address,
      },
      {
        label: "Vat number",
        value: this.company.vatNumber,
      },
      {
        label: "Email",
        value: this.company.email,
      },
      {
        label: "Phone",
        value: this.company.phone,
      },
    ];
  }
}
